import { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { Tooltip } from 'primereact/tooltip'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// local imports
import { IFilteredDoctorList } from 'types/HealthType'
import DoctorPhoto from './DoctorPhoto'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'
// import HealthService from 'service/HealthService'

export default function DoctorCard({
  doctor,
  openModal,
}: {
  doctor: IFilteredDoctorList
  openModal: (doc: IFilteredDoctorList) => void
}) {
  const {
    id,
    employeeId,
    location,
    block,
    floor,
    name,
    specialty,
    surname,
    title,
    explanation,
    // HealthServiceDoctorId,
    // IsFavorite,
  } = doctor || {}
  const { t } = useTranslation()
  const openAppointmentModal = () => openModal(doctor)
  const docSumRef = useRef<HTMLSpanElement>(null)
  const [hasTooltip, setHasTooltip] = useState(false)
  const locationStr = location.split(',')[0]

  useEffect(() => {
    const calculateLines = () => {
      const lineHeight = 14
      const lines = (docSumRef.current?.offsetHeight || 0) / lineHeight
      return lines >= 3
    }
    setHasTooltip(() => calculateLines())
  }, [])

  /* Favorite Doctor */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   HealthService.addDoctorFavorite(HealthServiceDoctorId).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   HealthService.removeDoctorFavorite(HealthServiceDoctorId).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}

        <DoctorPhoto doctorId={id} employeeId={employeeId} />
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <DocNameSurname>
            {title} {`${name} ${surname}`}
          </DocNameSurname>
          <DocSpeciality>{specialty}</DocSpeciality>
          <LocAddress>{`${locationStr || '---'}`}</LocAddress>
          <DocLocation>
            {block} | {floor}
          </DocLocation>

          {explanation ? (
            <>
              {hasTooltip && <StyledTooltip target=".doc-summary" />}
              <DocSummary
                data-pr-tooltip={hasTooltip ? explanation : null}
                data-pr-position="bottom"
                ref={docSumRef}
                className="doc-summary">
                {explanation}
              </DocSummary>
            </>
          ) : null}
        </div>

        <AppointmentBtn className="doc-summary" id="openAppointmentModal" onClick={openAppointmentModal}>
          {t('buttons.appointment')}
        </AppointmentBtn>
      </div>
    </StyledCard>
  )
}

const StyledTooltip = styled(Tooltip)`
  height: auto;
  max-width: 280px;
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
`

const StyledCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 300px;
  max-width: 300px;
  height: 330px;
  padding: 0 0 1rem;
  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 8px;
`
const CardHeaderOverlay = styled.div`
  position: relative;
  width: 300px;
  max-width: 300px;
  height: 50px;
  background: #ffdce8;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: 30px; // 28px
`

// const FavoriteContainer = styled.div`
//   position: absolute;
//   top: 15px;
//   right: 15px;
// `

const DocNameSurname = styled.span`
  font-size: 16px;
  line-height: 18px;
  height: 36px;
  font-weight: 700;
  color: #354147;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
export const DocSpeciality = styled.span`
  font-size: 14px;
  max-width: 240px;
  margin: 4px 0;
  color: #45bfe5;
  line-height: 18px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`

export const LocAddress = styled.div`
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`

export const DocLocation = styled.span`
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`
const DocSummary = styled.span`
  max-width: 275px;
  margin: 10px 0;
  user-select: none;
  max-height: 100px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #646464;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`
const AppointmentBtn = styled(Button)`
  width: 230px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
